import React from 'react';
import PropTypes from 'prop-types';

import {Box, MenuItem, Stack, TextField, Typography} from 'views/components';
import {ExpandMore} from 'views/icons';
import {Translate, translate} from 'views/module';

const SkillsNewName = (props) => {
  const {functionOptions, selectedFunction, setSelectedFunction, skillName, setSkillName} = props;

  return (
    <>
      <Stack sx={{gap: '8px'}}>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#A8A49E',
            lineHeight: '100%',
          }}
        >
          <Translate expression='skills.skills.New.SkillNameLabel' />
        </Typography>
        <Box
          sx={{
            'borderRadius': '8px',
            'border': '1px solid #E8E4DE',
            'backgroundColor': '#FFFFFF',
            'display': 'flex',
            'alignItems': 'center',
            'overflow': 'hidden',
            '&:focus-within': {
              borderColor: '#DA7955',
            },
          }}
        >
          <Typography
            component='span'
            sx={{
              pl: '12px',
              pr: '4px',
              fontSize: '14px',
              fontWeight: 400,
              color: '#6B6760',
            }}
          >
            /
          </Typography>
          <TextField
            value={skillName}
            onChange={setSkillName}
            variant='standard'
            placeholder={translate('skills.skills.New.SkillNamePlaceholder')}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                backgroundColor: 'transparent',
              },
              '& .MuiInputBase-input': {
                py: '24px',
                pr: '16px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '150%',
                color: '#1A1916',
                boxSizing: 'border-box',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#A8A49E',
                opacity: 1,
              },
              '& .MuiInput-underline:before': {
                borderBottom: '0',
              },
              '& .MuiInput-underline:after': {
                borderBottom: '0',
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: '0',
              },
            }}
          />
        </Box>
      </Stack>
      <Stack sx={{gap: '8px'}}>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#A8A49E',
            lineHeight: '100%',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='skills.skills.New.FunctionLabel' />
        </Typography>
        <TextField
          select
          fullWidth
          value={selectedFunction}
          onChange={setSelectedFunction}
          SelectProps={{
            displayEmpty: true,
            IconComponent: ExpandMore,
            renderValue: (value) => {
              if (!value) {
                return (
                  <Box
                    component='span'
                    sx={{
                      color: '#A8A49E',
                    }}
                  >
                    {translate('skills.skills.New.SelectPlaceholder')}
                  </Box>
                );
              }

              return functionOptions[value];
            },
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
            '& .MuiSelect-select': {
              px: '16px',
              py: '16px',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#000000',
              boxSizing: 'border-box',
            },
            '& .MuiSelect-icon': {
              color: '#000000',
              right: '14px',
            },
          }}
        >
          {
            Object.keys(functionOptions).map((key) => (
              <MenuItem
                key={key}
                value={key}
              >
                {functionOptions[key]}
              </MenuItem>
            ))
          }
        </TextField>
      </Stack>
    </>
  );
};

SkillsNewName.propTypes = {
  functionOptions: PropTypes.objectOf(PropTypes.string).isRequired,
  selectedFunction: PropTypes.string.isRequired,
  setSelectedFunction: PropTypes.func.isRequired,
  setSkillName: PropTypes.func.isRequired,
  skillName: PropTypes.string.isRequired,
};

export default React.memo(SkillsNewName);
